import React from 'react';

export const UserIcon = () => {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none">
      <path
        d="M14.0963 12.3777C15.1882 12.9262 16.1244 13.8065 16.8077 14.9072C16.9431 15.1252 17.0107 15.2342 17.0341 15.3851C17.0817 15.6918 16.8719 16.0689 16.5863 16.1903C16.4457 16.25 16.2876 16.25 15.9713 16.25M12.5963 9.14918C13.7076 8.59692 14.4713 7.45015 14.4713 6.125C14.4713 4.79985 13.7076 3.65308 12.5963 3.10082M11.0963 6.125C11.0963 7.98896 9.58527 9.5 7.72131 9.5C5.85735 9.5 4.34631 7.98896 4.34631 6.125C4.34631 4.26104 5.85735 2.75 7.72131 2.75C9.58527 2.75 11.0963 4.26104 11.0963 6.125ZM2.51574 14.7038C3.71147 12.9084 5.59834 11.75 7.72131 11.75C9.84428 11.75 11.7312 12.9084 12.9269 14.7038C13.1888 15.0971 13.3198 15.2937 13.3047 15.5449C13.293 15.7405 13.1648 15.98 13.0085 16.0982C12.8078 16.25 12.5317 16.25 11.9795 16.25H3.46308C2.91094 16.25 2.63487 16.25 2.43414 16.0982C2.27785 15.98 2.14963 15.7405 2.13789 15.5449C2.12281 15.2937 2.25378 15.0971 2.51574 14.7038Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
